export default [
	{
		path: '/admin/lucky-draw-rewards',
		name: 'lucky-draw-reward',
		meta: { requiresAuth: true },
		component: () => import('@/pages/lucky-draw/lucky-draw-reward/index.vue')
	}
]